import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import Layout from "../components/layout"
import BackgroundVideo from "../components/indexPage/BackgroundVideo"
import Intro from "../components/indexPage/Intro"
import Panel from "../components/indexPage/Panel"
import Main from "../components/indexPage/Main"
import List from "../components/indexPage/List"
import Collaborate from "../components/indexPage/Collaborate"
import Cards from "../components/indexPage/Cards"
import SEO from "../components/seo"
import MyCard from "../components/indexPage/MyCard"

const index = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <BackgroundVideo />
      <hr className="bg-secondary my-0" />
      <Main />
      <Intro />
      <Panel />
      <Cards />
      <Collaborate />
      <List />
      <MyCard />
    </Layout>
  )
}

export default index
